import ugr from '@/UGRoute';
import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Col,
  Container,
  Divider,
  FlexboxGrid,
  Input,
  InputGroup,
  Nav,
  Panel,
  Sidenav,
  Stack,
  Button
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import DashboardIcon from '@rsuite/icons/legacy/Dashboard';
import GroupIcon from '@rsuite/icons/legacy/Group';
import GearCircleIcon from '@rsuite/icons/legacy/GearCircle';
import globalIP from '@/GlobelIP';
import CompanyReg from './CompanyReg';
import UserReg from './UserReg';
import UserAuth from './UserAuth';
import Modules from './Modules';
import PSubM from './PSubM';
import CSubM from './CSubM';
import CollSubM from './CollSubM';
import CommenAuth from './CommenAuth';
import PReg from './PReg';
const AdminPanel = () => {
  const [activeView, setActiveView] = useState('dashboard');
  const [activeKey, setActiveKey] = useState('content1');
  const handleNavSelect = eventKey => {
    setActiveKey(eventKey);
  };
  const [data1, setData1] = useState([]);
  const [authorised, setAuthorised] = useState(false);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details?populate=*`);
      const json = await response.json();
      setAuthorised(json.data[0].attributes.Authorised);
      const processedData = json.data.map(item => ({
        label: item.attributes.cmpnm,
        value: item.attributes.cmpcd
      }));
      setData1(processedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const [openuser, setOpenUser] = useState(false);
  const handleCloseUser = () => setOpenUser(false);

  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar " justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">Administrator</h3>
              <Breadcrumb>
                <Breadcrumb.Item href={`${ugr}/dashboard`}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>admin</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>

          <Stack direction="column" alignItems="flex-end" spacing={24}>
            <Stack spacing={5}>
              <InputGroup inside>
                <Input placeholder="Search" type="text" />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
            </Stack>
          </Stack>
        </Stack>
        <Divider style={{ marginTop: 0, marginBottom: 0 }} />
        <FlexboxGrid justify="space-between">
          <FlexboxGrid.Item as={Col} colspan={24} md={4}>
            <div style={{ width: 250, height: '75vh', overflowY: 'scroll' }}>
              <Sidenav>
                <Sidenav.Body>
                  <Nav activeKey={activeView} onSelect={eventKey => setActiveView(eventKey)}>
                    <Nav.Item eventKey="dashboard" icon={<DashboardIcon />}>
                      Dashboard
                    </Nav.Item>
                    {authorised && (
                      <Nav.Item eventKey="users" icon={<GroupIcon />}>
                        Users
                      </Nav.Item>
                    )}
                    <Nav.Item eventKey="modules" icon={<GroupIcon />}>
                      Modules
                    </Nav.Item>
                    <Nav.Menu eventKey="submodule" title="Sub Module" icon={<GroupIcon />}>
                      <Nav.Item eventKey="3-1">Manage Product</Nav.Item>
                      <Nav.Item eventKey="3-2">Manage Catalogue</Nav.Item>
                      <Nav.Item eventKey="3-3">Manage Collection</Nav.Item>
                      <Nav.Item eventKey="3-4">Common Features</Nav.Item>
                    </Nav.Menu>
                    <Nav.Item eventKey="PRegistration" icon={<GearCircleIcon />}>
                      Product Registration
                    </Nav.Item>
                  </Nav>
                </Sidenav.Body>
              </Sidenav>
            </div>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} md={20}>
            <Panel>
              {activeView == 'dashboard' && (
                <>
                  <div>
                    <Panel>
                      <Stack spacing={5}>
                        <Button onClick={() => setOpen(true)} appearance="primary" color="cyan">
                          Company Registration
                        </Button>
                        <Button onClick={() => setOpenUser(true)} appearance="primary" color="cyan">
                          User Registration
                        </Button>
                      </Stack>
                      {/* Your page content here */}
                      <div></div>
                    </Panel>
                  </div>
                  <CompanyReg open={open} handleClose={handleClose} />
                  <UserReg openuser={openuser} handleCloseUser={handleCloseUser} />
                </>
              )}
              {activeView === 'users' && <UserAuth data1={data1} />}
              {activeView == 'modules' && <Modules />}
              {activeView == '3-1' && <PSubM />}
              {activeView == '3-2' && <CSubM />}
              {activeView == '3-3' && <CollSubM />}
              {activeView == '3-4' && <CommenAuth />}
              {activeView == 'PRegistration' && <PReg />}
            </Panel>
          </FlexboxGrid.Item>
          {/* <FlexboxGrid.Item as={Col} colspan={24} md={4}>
            <Nav
              activeKey={activeKey}
              onSelect={handleNavSelect}
              appearance="subtle"
              reversed
              vertical
            >
              <Nav.Item eventKey="content1">Category</Nav.Item>
              <Nav.Item eventKey="content2">ProductType</Nav.Item>
              <Nav.Item eventKey="content3">Collection</Nav.Item>
              <Nav.Item eventKey="content4">Finish</Nav.Item>
            </Nav>
          </FlexboxGrid.Item> */}
        </FlexboxGrid>

        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default AdminPanel;
